import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-white-source-license',
  standalone: true,
  imports: [],
  templateUrl: './white-source-license.component.html',
  styleUrl: './white-source-license.component.scss'
})

export class WhiteSourceLicenseComponent {
  licenseContent: SafeHtml = '';
  errorMessage: string = '';

  private destroy$ = new Subject<void>();

  constructor(
    private sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    // This will not load the app-navigation-bar component here
    this.sharedService.setHideNavigationBar(true);
  }

  ngOnInit(): void {
    this.loadLicenseContent();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Fetch HTML content from Azure Blob Storage and display directly
   */
  loadLicenseContent(): void {
    this.errorMessage = '';
    this.sharedService.getLicenseDocumentUrl('ascend-ui-attribution-report.html')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (htmlContent) => {
          // Bypass sanitization to preserve CSS and HTML structure
          // This is safe since the content comes from a trusted source (Azure Blob Storage)
          this.licenseContent = this.sanitizer.bypassSecurityTrustHtml(htmlContent);
        },
        error: (error) => {
          this.errorMessage = 'Failed to load license content. Please try again later.';
          console.error('Error fetching HTML content:', error);
        }
      });
  }
}
